export const CUUniId = 35;
